import { mailApiHeaders } from './mailApiHeaders';

/**
 * 관리자: 수신자·코드를 직접 지정.
 * 이용자(자동 발급 직후): requestId 만 — 서버가 본인 요청 행의 이메일·발급 코드로 1회 발송.
 */
export type SendBetaEventCodeIssueEmailParams =
  | {
      to: string;
      fullName: string;
      eventCode: string;
      organization?: string;
    }
  | { requestId: string };

export type SendBetaEventCodeIssueEmailResult =
  | { ok: true; messageId?: string }
  | { ok: false; skipped?: boolean; error: string };

type ApiOk = { ok: true; messageId?: string };
type ApiErr = { ok: false; skipped?: boolean; code?: string; message?: string; error?: string };

function apiUrl(): string {
  const base = (process.env.REACT_APP_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';
  return base
    ? `${base}/api/send-beta-event-code-issue-email`
    : '/api/send-beta-event-code-issue-email';
}

function mapApiResult(
  res: Response,
  data: ApiOk | ApiErr | null,
): SendBetaEventCodeIssueEmailResult {
  if (!data || typeof data !== 'object') {
    return {
      ok: false,
      skipped: false,
      error: res.ok ? 'EMPTY_RESPONSE' : `HTTP_${res.status}`,
    };
  }
  if ('ok' in data && data.ok === true) {
    return { ok: true, messageId: (data as ApiOk).messageId };
  }
  const err = data as ApiErr;
  return {
    ok: false,
    skipped: Boolean(err.skipped),
    error: err.error ?? err.message ?? err.code ?? 'SEND_FAILED',
  };
}

/** 요청자에게 베타 이벤트 이용권 코드 안내 메일 발송 */
export async function sendBetaEventCodeIssueEmail(
  params: SendBetaEventCodeIssueEmailParams,
): Promise<SendBetaEventCodeIssueEmailResult> {
  try {
    const res = await fetch(apiUrl(), {
      method: 'POST',
      headers: await mailApiHeaders(),
      body: JSON.stringify(params),
    });
    let data: ApiOk | ApiErr | null = null;
    try {
      data = (await res.json()) as ApiOk | ApiErr;
    } catch {
      data = null;
    }
    return mapApiResult(res, data);
  } catch (e) {
    return {
      ok: false,
      skipped: false,
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
